var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('db-page',{attrs:{"title":_vm.subject},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_c('ion-button',{attrs:{"expand":"full"},on:{"click":_vm.onEdit}},[_vm._v(" "+_vm._s(_vm.$tc('components.messageMessageDetailHeader02'))+" ")])]},proxy:true}])},[_c('db-html',{attrs:{"html":_vm.html}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }